<template>
  <div id="e3d-index" class="container">
    <div class="loader-mask" v-bind:class="{'hidden': !loaderActive}">
      <div class="loader" v-bind:class="{'hidden': !loaderActive}">
        <div></div>
        <div></div>
      </div>
    </div>

    <h3>Carica il / i file del tuo modello 3D</h3>

    <configuratore-new v-on:idstl="setIdStl"
                       v-on:clear-configurator="cleanItemToUpdate()"></configuratore-new>

    <br>

    <items-new-new v-show="getIdCart() !== undefined && getIdCart() !== null && getIdCart() !== ''"
                   v-on:update_product="updateProduct"
                   v-on:cart-items-tot="setTotalPrice"
                   :changeToUpdate="keyItemsNew"
                   :printers="printers"
                   :materials="materials"
                   :postProcesses="postProcesses"></items-new-new>

    <div v-show="getIdCart() !== undefined && getIdCart() !== null && getIdCart() !== ''"
         class="col-xs-12 col-md-4 col-md-offset-8 visualizzazione-tot">
      <div class="items-tot-price col-xs-12 noPadding">
        <div class="col-xs-7 noPadding"> Totale:</div>
        <div class="col-xs-5 noPadding prices" v-if="totalPrice.net > 0.00">{{totalPrice.net}} &euro;</div>
        <div class="col-xs-5 noPadding prices" v-else>- - &euro;</div>

        <div class="col-xs-7 noPadding"> Totale + IVA:</div>
        <div class="col-xs-5 noPadding prices" v-if="totalPrice.tax > 0.00">{{totalPrice.tax}} &euro;</div>
        <div class="col-xs-5 noPadding prices" v-else>- - &euro;</div>
        <div class="col-xs-12 noPadding">
          <span class="min-prices-err" v-if="statoCarrello === 0">
            Inserisci i tuoi dati per visualizzare i prezzi
          </span>
          <span class="min-prices-err"
                v-if="isMinPriceReached() && (statoCarrello > 0 && statoCarrello < 5)">
            Le tempistiche di spedizione indicate richiedono di raggiungere un minimo d’ordine di {{totalPrice.minPrice}}&euro;
          </span>
        </div>
      </div>
    </div>

    <div
      class="col-xs-12 col-md-4 col-md-offset-8 container-preventivo">
      <button v-if="statoCarrello === 0"
              class="btn btn-md btn-stroke btn-row col-xs-12 noPadding button-blu-effect button-price-proceed"
              v-on:click="modal.choose.show = true">
        Visualizza prezzi
      </button>

      <button v-if="(statoCarrello > 0 && statoCarrello < 5)"
              class="col-xs-12 noPadding btn btn-md btn-stroke btn-row button-blu-effect button-price-proceed"
              v-on:click="clickProcediAlPagamento()">
        Procedi al pagamento
      </button>
    </div>

    <modal id="chooseLogin" v-model="modal.choose.show" effect="fade">

      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title col-xs-4">
          <b>Registrazione</b>
        </h4>
      </div>

      <div class="modal-body clearfix">
        <div class="content-left col-xs-6 noPadding">
          <a class="choose-modal-icon" v-on:click="getTokenTmp()">
            <icon name="elm-twitter" scale="2.5"></icon>
          </a>
          <p class="text-click" v-on:click="getTokenTmp">TWITTER LOGIN</p>
        </div>

        <div class="content-right col-xs-6 noPadding">
          <a class="choose-modal-icon" v-on:click="priceModal">
            <icon name="elm-user" scale="2.5"></icon>
          </a>
          <p class="text-click" v-on:click="priceModal">COMPILA FORM</p>
        </div>

        <div class="content-checkbox col-xs-12 noPadding">
          <div class="dataEntry agreement privacy">
            <input data-vv-scope="privacy" v-model="modal.privacyCheck" class="checkbox" type="checkbox"
                   id="authPrivacy" name="privacy" v-validate="'required'">
            <label for="authPrivacy" class="checkbox-label"></label>
            <span v-bind:class="{'error': errors.has('privacy.privacy')}">(*) Ho letto e accettato l'<a
              class="link-agreement" href="https://www.elmec.com/documents/3d_Informativa privacy configuratore.pdf"
              target="_blank">informativa sulla privacy</a></span>
          </div>

          <div class="dataEntry agreement tratDati">
            <input v-model="modal.checkMarketing" class="checkbox" type="checkbox" id="authTratDati"
                   name="authTratDati">
            <label for="authTratDati" class="checkbox-label"></label>
            <span>Autorizzo il trattamento dei dati per lo svolgimento di <a class="link-agreement"
                                                                             href="https://www.elmec.com/documents/3d_Informativa privacy configuratore.pdf"
                                                                             target="_blank">attività di marketing con strumenti automatizzati (sms, mms, via e-mail) e con strumenti non automatizzati (telefono con operatore o posta cartacea).</a></span>
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <p class="left">I campi contrassegnati con (*) sono obbligatori.</p>
      </div>
    </modal>

    <modal id="calcPrice" class="e3d-modal" v-model="modal.price.show" effect="fade">

      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title col-xs-4">
          <b>Compila il form</b>
        </h4>
      </div>

      <div class="modal-body clearfix">
        <div class="dataEntry col-xs-12 noPadding">
          <div class="client-type col-xs-12 col-sm-12 noPadding">
            <div class="floating-box icon col-xs-4" :class="{ 'active': this.modal.codeTypeUser === 0}"
                 @click="modal.codeTypeUser = 0">
              <icon name="elm-azienda" scale="1.7"></icon>
              <p>Azienda</p>
            </div>
            <div class="floating-box icon user-icon col-xs-4" :class="{ 'active': modal.codeTypeUser === 1 }"
                 @click="modal.codeTypeUser = 1">
              <icon name="elm-user" scale="1.5"></icon>
              <p>Privato</p>
            </div>
            <div class="floating-box icon user-icon col-xs-4" :class="{ 'active': modal.codeTypeUser === 2 }"
                 @click="modal.codeTypeUser = 2">
              <icon name="elm-user" scale="1.5"></icon>
              <p>Pubblica Amministrazione</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group left">
              <p v-bind:class="{'error': errors.has('noPrice.nameNoPrice')}">NOME (*)</p>
              <input data-vv-scope="noPrice" :value="modal.nome" @input="setValue($event, 'nome')" type="text"
                     class="form-control"
                     v-validate="'required|alpha_spaces'" name="nameNoPrice">
            </div>
            <div class="form-group right">
              <p v-bind:class="{'error': errors.has('noPrice.surnameNoPrice')}">COGNOME (*)</p>
              <input data-vv-scope="noPrice" :value="modal.cognome" @input="setValue($event, 'cognome')" type="text"
                     class="form-control"
                     v-validate="'required|alpha_spaces'" name="surnameNoPrice">
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group full-width col-xs-12">
              <p>TELEFONO</p>
              <input :value="modal.tel" @input="setValue($event, 'tel')" type="number" class="form-control">
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group full-width col-xs-12 noPadding">
              <p v-bind:class="{'error': errors.has('noPrice.mailNoPrice')}">E-MAIL
                <span v-if="modal.codeTypeUser !== 1" v-bind:class="{'error': errors.has('noPrice.mailNoPrice')}">AZIENDALE</span>
                (*)
              </p>
              <input data-vv-scope="noPrice" :value="modal.mail" @input="setValue($event, 'mail')" type="email"
                     class="form-control"
                     v-validate="'required|email'" name="mailNoPrice">
            </div>
          </div>

          <div v-bind:class="{'hidden': modal.codeTypeUser === 1}" class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group full-width">
              <p v-if="modal.codeTypeUser === 0" v-bind:class="{'error': errors.has('company.azienda')}">AZIENDA (*)</p>
              <p v-else v-bind:class="{'error': errors.has('company.azienda')}">ENTE (*)</p> <!-- sezione ente-->
              <input data-vv-scope="noPrice" :value="modal.azienda" @input="setValue($event, 'azienda')" type="text"
                     class="form-control"
                     v-validate="modal.codeTypeUser === 1 ? '' : 'required'" name="azienda">
            </div>
          </div>

          <div id="error-message" v-if="errors.items.lenght > 0">
            <p>Compilare tutti i campi obbligatori</p>
          </div>

          <div class="dataEntry agreement">
            <input data-vv-scope="privacy" :value="modal.saveData" @input="setValue($event, 'saveData')"
                   class="checkbox" type="checkbox"
                   id="saveData">
            <label for="saveData" class="checkbox-label"></label>
            <span>Voglio salvare i miei dati per acquisti futuri</span>
          </div>

          <div class="modal-buttons col-xs-12 noPadding">
            <input class="btn btn-md btn-stroke button-blu-effect right" type="button" value="Annulla"
                   v-on:click="modal.price.show = false">
            <input class="btn btn-md btn-stroke button-blu-effect left"
                   type="submit" value="Conferma" v-on:click="calcPrice">
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <p class="left">I campi contrassegnati con (*) sono obbligatori.</p>
      </div>
    </modal>

    <modal id="askOffer" class="e3d-modal" v-model="modal.offer.show" effect="fade">

      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title col-xs-4">
          <b>Compila il form</b>
        </h4>
      </div>

      <div class="modal-body clearfix">
        <div class="dataEntry col-xs-12 noPadding">
          <div class="client-type col-xs-12 col-sm-12 noPadding">
            <div class="floating-box icon col-xs-4" :class="{ 'active': modal.codeTypeUser === 0 }"
                 @click="modal.codeTypeUser = 0">
              <icon name="elm-azienda" scale="1.7"></icon>
              <p>Azienda</p>
            </div>
            <div class="floating-box icon user-icon col-xs-4" :class="{ 'active': modal.codeTypeUser === 1 }"
                 @click="modal.codeTypeUser = 1">
              <icon name="elm-user" scale="1.5"></icon>
              <p>Privato</p>
            </div>
            <div class="floating-box icon user-icon col-xs-4" :class="{ 'active': modal.codeTypeUser === 2 }"
                 @click="modal.codeTypeUser = 2">
              <icon name="elm-user" scale="1.5"></icon>
              <p>Pubblica Amministrazione</p>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group left">
              <p v-bind:class="{'error': errors.has('common.nome')}">NOME (*)</p>
              <input data-vv-scope="common" :value="modal.nome" @input="setValue($event, 'nome')" type="text"
                     class="form-control"
                     v-validate="'required|alpha_spaces'" name="nome">
            </div>
            <div class="form-group right">
              <p v-bind:class="{'error': errors.has('common.cognome')}">COGNOME (*)</p>
              <input data-vv-scope="common" :value="modal.cognome" @input="setValue($event, 'cognome')" type="text"
                     class="form-control"
                     v-validate="'required|alpha_spaces'" name="cognome">
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group"
                 v-bind:class="[{'full-width col-xs-12 noPadding': modal.codeTypeUser !== 1}, {'left': modal.codeTypeUser === 1}]">
              <p v-bind:class="{'error': errors.has('common.tel')}">TELEFONO (*)</p>
              <input data-vv-scope="common" :value="modal.tel" @input="setValue($event, 'tel')" type="number"
                     class="form-control"
                     v-validate="validation.required.phone" name="tel">
            </div>

            <div class="form-group"
                 v-bind:class="[{'full-width col-xs-12 noPadding': modal.codeTypeUser !== 1}, {'hidden': modal.codeTypeUser === 1}]">
              <p v-bind:class="{'error': errors.has('company.sdi')}">SDI (*)</p>

              <div class="container-info-sdi"
                   v-on:click="isSdiDetailOpen = !isSdiDetailOpen">
                <!--                <div class="bordered-info">?</div>-->
                <icon name="elm-info"></icon>

                <div class="sdi-detail-open" v-if="isSdiDetailOpen">
                  Il Codice Destinatario è un campo della fattura elettronica in cui devi inserire il codice
                  identificativo alfanumerico di 7 cifre del ricevente della fattura. Il Codice Destinatario definisce
                  l'indirizzo telematico a cui vengono inviate le fatture e serve quindi per indicare al Sistema di
                  Interscambio (SDI) a chi recapitare le fatture.
                </div>
              </div>

              <input data-vv-scope="company" :value="modal.sdi" @input="setValue($event, 'sdi')" class="form-control"
                     v-validate="'required'" name="sdi">
            </div>

            <div v-bind:class="{'hidden': modal.codeTypeUser === 1}" class="form-group left">
              <p v-if="modal.codeTypeUser === 0" v-bind:class="{'error': errors.has('company.piva')}">
                PARTITA IVA (*)
              </p>
              <p v-else v-bind:class="{'error': errors.has('company.piva')}">PARTITA IVA</p> <!-- sezione ente-->
              <input data-vv-scope="company" :value="modal.piva" @input="setValue($event, 'piva')" type="text"
                     class="form-control"
                     v-validate="(modal.codeTypeUser === 1 || modal.codeTypeUser === 2) ? '' : 'required|pIva'"
                     name="piva">
            </div>

            <div v-if="modal.codeTypeUser === 1" class="form-group right">
              <p v-bind:class="{'error': errors.has('private.cfisc')}">CODICE FISCALE (*)</p>
              <input data-vv-scope="private" :value="modal.cfisc" @input="setValue($event, 'cfisc')" type="text"
                     class="form-control"
                     v-validate="modal.codeTypeUser !== 1 ? '' : validation.required.cfisc" name="cfisc">
            </div>
            <div v-else class="form-group right">
              <p v-bind:class="{'error': errors.has('company.cfiscCompany')}">CODICE FISCALE</p>
              <input data-vv-scope="company" :value="modal.cfisc" @input="setValue($event, 'cfisc')" type="text"
                     class="form-control"
                     v-validate="validation.required.cfiscCompany" name="cfiscCompany">
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group full-width col-xs-12 noPadding">
              <p v-bind:class="{'error': errors.has('noPrice.mailNoPrice')}">E-MAIL
                <span v-if="modal.codeTypeUser !== 1" v-bind:class="{'error': errors.has('noPrice.mailNoPrice')}">AZIENDALE</span>
                (*)
              </p>
              <input data-vv-scope="common" :value="modal.mail" @input="setValue($event, 'mail')" type="email"
                     class="form-control"
                     v-validate="'required|email'" name="mail">
            </div>
          </div>

          <div v-bind:class="{'hidden': modal.codeTypeUser === 1}" class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group left">
              <p v-if="modal.codeTypeUser === 0" v-bind:class="{'error': errors.has('company.azienda')}">AZIENDA (*)</p>
              <p v-else v-bind:class="{'error': errors.has('company.azienda')}">ENTE (*)</p> <!-- sezione ente-->
              <input data-vv-scope="company" :value="modal.azienda" @input="setValue($event, 'azienda')" type="text"
                     class="form-control"
                     v-validate="modal.codeTypeUser === 1 ? '' : 'required'" name="azienda">
            </div>

            <div class="form-group right">
              <p v-bind:class="{'error': errors.has('company.ruolo')}">RUOLO (*)</p>
              <input data-vv-scope="company" :value="modal.ruolo" @input="setValue($event, 'ruolo')" type="text"
                     class="form-control"
                     v-validate="modal.codeTypeUser === 1 ? '' : 'required'" name="ruolo">
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 noPadding">
            <div class="form-group left">
              <p v-bind:class="{'error': errors.has('common.fatturazione')}">INDIRIZZO DI FATTURAZIONE (*)</p>
              <input data-vv-scope="common" :value="modal.fatturazione.address"
                     @input="setValue($event, 'fatturazione', 'address')" type="text" class="form-control"
                     v-validate="'required'" name="fatturazione">
            </div>

            <div class="form-group right">
              <p v-bind:class="{'error': errors.has('common.city')}">CITTA (*)</p>
              <input data-vv-scope="common" :value="modal.fatturazione.city"
                     @input="setValue($event, 'fatturazione', 'city')" type="text" class="form-control"
                     v-validate="'required'" name="city">
            </div>

            <div class="form-group left">
              <p v-bind:class="{'error': errors.has('common.zip')}">CAP (*)</p>
              <input data-vv-scope="common" :value="modal.fatturazione.zip"
                     @input="setValue($event, 'fatturazione', 'zip')" type="number" class="form-control"
                     v-validate="validation.required.cap"
                     name="zip">
            </div>

            <div class="form-group right">
              <p v-bind:class="{'error': errors.has('common.country')}">PAESE (*)</p>
              <input data-vv-scope="common" :value="modal.fatturazione.country"
                     @input="setValue($event, 'fatturazione', 'country')" type="text" class="form-control"
                     v-validate="'required'" name="country" readonly>
            </div>

            <div class="dataEntry agreement spedizione">
              <input data-vv-scope="privacy" v-model="modal.hasSpedizione" class="checkbox" type="checkbox"
                     id="checkSpedizione2">
              <label for="checkSpedizione2" class="checkbox-label"></label>
              <span>Seleziona se l'indirizzo di spedizione è diverso da quello di fatturazione</span>
            </div>

            <div v-if="modal.hasSpedizione">
              <div class="form-group left">
                <p v-bind:class="{'error': errors.has('common.addSpe')}">INDIRIZZO DI SPEDIZIONE (*)</p>
                <input data-vv-scope="common" :value="modal.spedizione.address"
                       @input="setValue($event, 'spedizione', 'address')" type="text" class="form-control"
                       v-validate="!modal.hasSpedizione ? '' : 'required'" name="addSpe">
              </div>

              <div class="form-group right">
                <p v-bind:class="{'error': errors.has('common.citySpe')}">CITTA DI SPEDIZIONE (*)</p>
                <input data-vv-scope="common" :value="modal.spedizione.city"
                       @input="setValue($event, 'spedizione', 'city')" type="text" class="form-control"
                       v-validate="!modal.hasSpedizione ? '' : 'required'" name="citySpe">
              </div>

              <div class="form-group left">
                <p v-bind:class="{'error': errors.has('common.zipSpe')}">CAP DI SPEDIZIONE (*)</p>
                <input data-vv-scope="common" :value="modal.spedizione.zip"
                       @input="setValue($event, 'spedizione', 'zip')" type="number" class="form-control"
                       v-validate="!modal.hasSpedizione ? '' : validation.required.cap" name="zipSpe">
              </div>

              <div class="form-group right">
                <p v-bind:class="{'error': errors.has('common.countrySpe')}">PAESE DI SPEDIZIONE (*)</p>
                <input data-vv-scope="common" :value="modal.spedizione.country"
                       @input="setValue($event, 'spedizione', 'country')" type="text" class="form-control"
                       v-validate="!modal.hasSpedizione ? '' : 'required'" name="countrySpe" readonly>
              </div>
            </div>
          </div>

          <div class="privacy-flags col-xs-12 col-sm-12 noPadding">
            <div class="dataEntry agreement vendita">
              <input data-vv-scope="common" v-model="modal.venditaCheck" class="checkbox" type="checkbox" key="vendita"
                     id="authVendita" name="vendita" v-validate="'required'">
              <label for="authVendita" class="checkbox-label"></label>
              <span
                v-bind:class="{'error': errors.has('common.vendita')}">(*) Ho letto e accettato le <a
                class="link-agreement" href="https://www.elmec.com/documents/3d_Condizioni generali di servizio.pdf"
                target="_blank">Condizioni Generali di Servizio.</a></span>
            </div>

          </div>

          <div v-if="errors.items.lenght > 0">
            <p>Compilare tutti i campi obbligatori</p>
          </div>

          <div class="dataEntry agreement">
            <input data-vv-scope="privacy" v-model="modal.saveData" class="checkbox" type="checkbox"
                   id="saveData">
            <label for="saveData" class="checkbox-label"></label>
            <span>Voglio salvare i miei dati per acquisti futuri</span>
          </div>

          <div class="modal-buttons col-xs-12 noPadding">
            <input class="btn btn-md btn-stroke right button-new-style-orange" type="button" value="Annulla"
                   v-on:click="modal.offer.show = false">
            <input class="btn btn-md btn-stroke left button-new-style"
                   type="submit" value="Conferma" v-on:click="askPreventivo">
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <p class="left">I campi contrassegnati con (*) sono obbligatori.</p>
      </div>
    </modal>

    <modal id="forcePostProcess" class="e3d-modal" v-model="modal.forcePostProcess.show" effect="fade">

      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title title-width-info col-xs-12">
          <b>Vuoi provare il "Vapor Smoothing"?</b>
          <a href="https://www.elmec.com/3d/risorse/documenti/ELMEC3D_CHEMICAL_POLISHING.pdf" target="_blank" class="dettaglio">
            <icon name="elm-info"></icon>
          </a>
        </h4>
      </div>

      <div class="modal-body clearfix">
        Per ottenere il meglio dalle tue stampe prova la nuova finitura
        "<a href="https://www.elmec.com/3d/risorse/documenti/ELMEC3D_CHEMICAL_POLISHING.pdf" target="_blank" class="dettaglio">Vapor Smoothing</a>".<br><br>
        Cliccando su "SI" modificherai la finitura di tutte le stampe. I prezzi verranno ricalcolati. Potrai sempre tornare indietro.<br>
        Cliccando su "NO" manterrai la finitura selezionata.
        <div class="modal-buttons col-xs-12 noPadding">
          <input class="btn btn-md btn-stroke right button-new-style-transparent" type="button" value="NO"
                 v-on:click="modalForcePostProcessSayNo" :disabled="buttonDisabled">
          <input class="btn btn-md btn-stroke left button-new-style"
                 type="submit" value="SI" v-on:click="modalForcePostProcessSayYes" :disabled="buttonDisabled">
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer" style="border: 0; padding: 0">
      </div>

    </modal>
  </div>
</template>

<script>
  import Bus from '@/components/Bus.js'
  import {modal} from 'vue-strap'
  import swal from 'sweetalert2'
  import {Validator} from 'vee-validate'
  import ConfiguratoreNew from './ConfiguratoreNew'
  import ItemsNewNew from './ItemsNewNew'
  import {generalMixins} from '../mixins/generalMixins'

  const axios = require('axios')

  export default {
    components: {
      ItemsNewNew,
      ConfiguratoreNew,
      modal,
      swal,
      Validator
    },
    name: 'IndexNew',
    mixins: [generalMixins],
    data () {
      return {
        keyItemsNew: 0,
        showPriceBtn: true,
        showPreventivo: false,
        loaderActive: false,
        isSdiDetailOpen: false,
        buttonDisabled: false,
        postProcessToForce: 'Vapor Smoothing', // Used to force user to use Vapor Smoothing post_process
        modal: {
          saveData: false,
          codeTypeUser: 0, // 0 = azienda, 1 = privato, 2 = pub. amm.
          choose: {
            show: false
          },
          price: {
            privacyCheck: false,
            datiCheck: false,
            show: false
          },
          offer: {
            venditaCheck: false,
            show: false
          },
          forcePostProcess: {
            show: false
          },
          nome: '',
          cognome: '',
          tel2: '',
          tel: '',
          mail: '',
          cfisc: '',
          piva: '',
          azienda: '',
          ruolo: '',
          checkMarketing: false,
          spedizione: {
            address: '',
            city: '',
            zip: '',
            country: 'IT'
          },
          fatturazione: {
            address: '',
            city: '',
            zip: '',
            country: 'IT'
          },
          hasSpedizione: false,
          pec: '',
          sdi: ''
        },
        validation: {
          required: {
            phone: 'required|numeric|min:8|max:11',
            cap: 'required|numeric|length:5',
            cfisc: {
              required: true,
              regex: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$'
            },
            cfiscCompany: {
              required: false,
              regex: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$'
            },
            piva: 'required|pIva'
          },
          phone: 'numeric|min:8|max:11',
          cap: 'required|numeric|length:5',
          cfisc: {
            required: false,
            regex: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$'
          },
          piva: 'pIva'
        },
        itemToUpdate: {},
        printers: [],
        materials: [],
        postProcesses: [],
        totalPrice: {
          net: 0.00,
          tax: 0.00,
          minPrice: 0
        },
        statoCarrello: 5,
        isThereErrorsInCart: false,
        testInput: {
          prova: null
        }
      }
    },
    created: function () {
      Validator.extend('pIva', {
        getMessage: function (field) {
          return 'Partita IVA non corretta'
        },
        validate: function (value) {
          return new Promise(function (resolve) {
            return resolve({
              valid: value && (value.match(/^[A-Za-z]{2}[0-9]{11,11}$/) != null || value.match(/^[0-9]{11}$/) != null)
            })
          })
        }
      })
      this.$validator.attach({
        name: 'pIva',
        rules: 'pIva'
      })
    },
    mounted: function () {
      this.$nextTick(() => {
        this.isSocialLogin()
        this.getPrinters()
        this.getPostProcesses()
        this.loadUserDataCart()
      })
    },
    methods: {
      setValue: function (event, variableName, secondLevelName) {
        let variableValue = event.target.value
        if (secondLevelName) {
          this.modal[variableName][secondLevelName] = variableValue.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        } else {
          this.modal[variableName] = variableValue.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        }
      },
      getIdCart: function () {
        return localStorage.getItem('id_cart')
      },
      setTotalPrice: function () {
        let id_cart = this.getIdCart()

        if (id_cart && id_cart !== '') {
          axios.get('/api/v1/carts/' + id_cart)
            .then((response) => {
              if (response.status === 200) {
                this.statoCarrello = response.data.result.status
                this.totalPrice = {
                  net: parseFloat(response.data.result.tot_net).toFixed(2),
                  tax: parseFloat(response.data.result.tot_tax).toFixed(2),
                  minPrice: parseFloat(response.data.result.min_order).toFixed(2)
                }

                let isThereErrors = false

                response.data.result.rows.forEach(ic => {
                  let arrErr = JSON.parse(ic.warning.replace(/'/g, '"'))
                  isThereErrors = isThereErrors || arrErr.length > 0
                })

                this.isThereErrorsInCart = isThereErrors
              }
            })
            .catch(() => {
              this.resetSiteDueInvalidCart()
            })
        }
      },
      refreshPage: function () {
        this.$router.go('/')
      },
      priceModal: function () {
        this.$validator.validateAll('privacy').then(result => {
          if (result) {
            this.modal.choose.show = false
            this.modal.price.show = true
          }
        })
      },
      loadUserDataCart: function () {
        axios.get('/api/v1/carts/' + this.getIdCart() + '/user-data')
          .then(response => {
            if (response.status === 200 && response.data.code === 20) {
              this.modal.codeTypeUser = response.data.result.type_user ? response.data.result.type_user : 0
              this.modal.nome = response.data.result.client_name ? response.data.result.client_name : ''
              this.modal.cognome = response.data.result.client_surname ? response.data.result.client_surname : ''
              this.modal.mail = response.data.result.client_email ? response.data.result.client_email : ''
              this.modal.checkMarketing = response.data.result.allow_marketing && response.data.result.allow_marketing === 1 ? true : false
              this.modal.privacyCheck = response.data.result.accept_privacy && response.data.result.accept_privacy === 1 ? true : false
              this.modal.fatturazione.address = response.data.result.invoice_address ? response.data.result.invoice_address : ''
              this.modal.fatturazione.city = response.data.result.invoice_city ? response.data.result.invoice_city : ''
              this.modal.fatturazione.zip = response.data.result.invoice_cap ? response.data.result.invoice_cap : ''
              this.modal.spedizione.address = response.data.result.shipping_address ? response.data.result.shipping_address : ''
              this.modal.spedizione.city = response.data.result.shipping_city ? response.data.result.shipping_city : ''
              this.modal.spedizione.zip = response.data.result.shipping_cap ? response.data.result.shipping_cap : ''
              this.modal.tel = response.data.result.client_phone ? response.data.result.client_phone : ''
              this.modal.cfisc = response.data.result.client_cfisc ? response.data.result.client_cfisc : ''
              this.modal.piva = response.data.result.client_piva ? response.data.result.client_piva : ''
              this.modal.azienda = response.data.result.client_rag_soc ? response.data.result.client_rag_soc : ''
              this.modal.ruolo = response.data.result.client_role ? response.data.result.client_role : ''
              this.modal.venditaCheck = response.data.result.service_general_condition ? response.data.result.service_general_condition : ''
              this.modal.sdi = response.data.result.sdi ? response.data.result.sdi : ''
            }

            this.loadDataLocalStorage() // TODO: si può rimuovere?
          })
          .catch(() => {
            this.loadDataLocalStorage()
          })
      },
      loadDataLocalStorage: function () {
        let userData = localStorage.getItem('user')

        if (userData && userData !== null) {
          let newObj = JSON.parse(userData)

          this.modal.codeTypeUser = newObj.codeTypeUser
          this.modal.nome = newObj.nome
          this.modal.cognome = newObj.cognome
          this.modal.mail = newObj.mail
          this.modal.checkMarketing = newObj.checkMarketing
          this.modal.privacyCheck = newObj.privacyCheck
          this.modal.fatturazione.address = newObj.fatturazione.address
          this.modal.fatturazione.city = newObj.fatturazione.city
          this.modal.fatturazione.zip = newObj.fatturazione.zip
          this.modal.spedizione.address = newObj.spedizione.address
          this.modal.spedizione.city = newObj.spedizione.city
          this.modal.spedizione.zip = newObj.spedizione.zip
          this.modal.tel = newObj.tel
          this.modal.cfisc = newObj.cfisc ? newObj.cfisc : ''
          this.modal.piva = newObj.piva ? newObj.piva : ''
          this.modal.azienda = newObj.azienda ? newObj.azienda : ''
          this.modal.ruolo = newObj.ruolo ? newObj.ruolo : ''
          this.modal.venditaCheck = newObj.venditaCheck
          this.modal.saveData = newObj.saveData
          this.modal.hasSpedizione = newObj.hasSpedizione
          this.modal.sdi = newObj.sdi
        }
      },
      isSocialLogin: function () {
        if (this.$route.query !== {}) {
          if (this.$route.query.oauth_token !== undefined && this.$route.query.oauth_verifier !== undefined) {
            this.getTokenAccessTwitter(this.$route.query.oauth_verifier)
          } else {
            // console.log('CHECKING: ', this.$route.query.code, ' and ', this.$route.query.state)
            if (this.$route.query.code !== undefined && this.$route.query.state !== undefined) {
              this.getTokenAccessLinkedin(this.$route.query.code, this.$route.query.state)
            }
          }
        }
      },
      setIdStl: function (id_stl) {
        this.itemToUpdate.id_stl = id_stl
        this.$forceUpdate()
      },
      cleanItemToUpdate: function () {
        this.itemToUpdate = {}
      },
      updateProduct: function (item) {
        this.itemToUpdate = item
      },
      getPrinters: function () {
        axios.get('/api/v1/technology')
          .then((response) => {
            if (response.status === 200) {
              this.printers = response.data.result
              this.printers.forEach((p) => {
                this.getMaterial(p.ID)
              })
            }
          })
      },
      getMaterial: function (idPrinter) {
        axios.get('/api/v1/technology/' + idPrinter + '/material')
          .then((response) => {
            if (response.status === 200 && response.data.result !== null) {
              this.materials = this.materials.concat(response.data.result)
            }
          })
      },
      getPostProcesses: function () {
        axios.get('/api/v1/post-process')
          .then((response) => {
            if (response.status === 200) {
              this.postProcesses = response.data.result
            }
          })
      },
      calcPrice: function () {
        this.$validator.validateAll('noPrice').then(result => {
          if (result) {
            this.modal.price.show = false

            let userData = {
              type_user: this.modal.codeTypeUser,
              nome: this.modal.nome,
              cognome: this.modal.cognome,
              email: this.modal.mail,
              allow_marketing: this.modal.checkMarketing ? 1 : 0,
              telefono: this.modal.tel,
              accept_privacy: this.modal.privacyCheck ? 1 : 0,
            }

            if ([0, 2].indexOf(this.modal.codeTypeUser) > -1) {
              userData['rag_soc'] = this.modal.azienda
            }

            this.saveDataToLS()

            axios.put('/api/v1/carts/' + this.getIdCart() + '/user-data', userData)
              .then(response => {
                if (response.status === 200 && response.data.code === 20) {
                  swal('Salvataggio informazioni', 'Dati utente salvati correttamente!', 'success')
                  this.keyItemsNew++
                }
              })
              .catch((error) => {
                if (error.response.status === 400) this.badRequestModal(error.response.data)
                else swal('Errore salvataggio informazioni', 'Verifica il contenuto dei tuoi dati. In caso di problemi contattati', 'error')
              })
            this.showPriceBtn = false
            this.showPreventivoBtn = true
          } else {
            swal('Errore salvataggio informazioni', 'I dati inseriti non sono validi', 'error')
          }
        })
      },
      saveAllUserData: function () {
        this.$validator.validateAll('noPrice').then(result => {
          if (result) {
            this.modal.price.show = false

            let userData = {
              type_user: this.modal.codeTypeUser,
              nome: this.modal.nome,
              cognome: this.modal.cognome,
              email: this.modal.mail,
              invoice_address: this.modal.fatturazione.address,
              invoice_city: this.modal.fatturazione.city,
              invoice_cap: this.modal.fatturazione.zip,
              invoice_country: this.modal.fatturazione.country,
              telefono: this.modal.tel,
              service_general_condition: this.modal.venditaCheck ? 1 : 0,
            }

            if (this.modal.hasSpedizione) {
              userData.shipping_address = this.modal.spedizione.address
              userData.shipping_city = this.modal.spedizione.city
              userData.shipping_cap = this.modal.spedizione.zip
              userData.shipping_country = this.modal.spedizione.country
            } else {
              userData.shipping_address = userData.invoice_address
              userData.shipping_city = userData.invoice_city
              userData.shipping_cap = userData.invoice_cap
              userData.shipping_country = userData.invoice_country
            }

            // 0 = company
            // 1 = private user
            // 2 = public administration
            if ([0, 1, 2].indexOf(this.modal.codeTypeUser) > -1 && this.modal.cfisc) {
              userData.cfisc = this.modal.cfisc
            }
            if ([0, 2].indexOf(this.modal.codeTypeUser) > -1 && this.modal.piva) {
              userData.piva = this.modal.piva
            }
            if ([0, 2].indexOf(this.modal.codeTypeUser) > -1 && this.modal.azienda) {
              userData.rag_soc = this.modal.azienda
            }
            if ([0, 2].indexOf(this.modal.codeTypeUser) > -1 && this.modal.ruolo) {
              userData.client_role = this.modal.ruolo
            }
            if ([0, 2].indexOf(this.modal.codeTypeUser) > -1 && this.modal.sdi) {
              userData.sdi = this.modal.sdi
            }

            axios.put('/api/v1/carts/' + this.getIdCart() + '/all-user-data', userData)
              .then(response => {
                if (response.status === 200 && response.data.code === 20) {
                  swal('Salvataggio informazioni', 'Dati utente salvati correttamente!', 'success')

                  swal({
                    title: 'Salvataggio informazioni',
                    type: 'success',
                    text: 'Dati utente salvati correttamente!'
                  }).then((result) => {
                    this.$router.push({name: 'PaymentCheckout'})
                  })
                  this.keyItemsNew++
                }
              })
              .catch((error) => {
                if (error.response.status === 400) this.badRequestModal(error.response.data)
                else swal('Errore salvataggio informazioni', 'Verifica il contenuto dei tuoi dati. In caso di problemi contattati', 'error')
              })
            this.showPriceBtn = false
            this.showPreventivoBtn = true
          } else {
            swal('Errore salvataggio informazioni', 'I dati inseriti non sono validi', 'error')
          }
        })
      },
      askPreventivo: function () {
        if (parseFloat(this.totalPrice.minPrice) > 0 && parseFloat(this.totalPrice.tax) > parseFloat(this.totalPrice.minPrice)) {
          let nameFieldToValid = ''

          if (this.modal.codeTypeUser === 0 || this.modal.codeTypeUser === 2) {
            nameFieldToValid = 'company'
          } else if (this.modal.codeTypeUser === 1) {
            nameFieldToValid = 'private'
          }

          Promise.all([this.$validator.validateAll('common'), this.$validator.validateAll(nameFieldToValid)])
            .then(result => {

              this.saveDataToLS()

              if (result[0] && result[1]) {
                this.saveAllUserData()
              } else {
                swal('Errore', 'Compilare tutti i campi prima di procedere', 'error')
              }
            })
        } else {
          swal('Errore', 'Prezzo minimo ordine non raggiunto<br>Il minimo &egrave; ' + this.totalPrice.minPrice + '&euro;', 'error')
        }
      },
      getTokenTmp: function () {
        this.$validator.validateAll('privacy').then(result => {
          if (result) {
            axios.get('/api/v1/social-login/twitter/tmpToken')
              .then(resp => {
                if (resp.status === 200) {
                  localStorage.setItem('ro_key', resp.data.result.oauth_token)
                  localStorage.setItem('ro_secret', resp.data.result.oauth_token_secret)
                  window.location.href = 'https://api.twitter.com/oauth/authenticate?oauth_token=' + resp.data.result.oauth_token
                }
              })
              .catch(err => {
                swal('Attenzione', 'Attualmente la funzione di social login non è disponibile, ti invitiamo ad usare la form.', 'error')
              })
          }
        })
      },
      getTokenAccessTwitter: function (oauthVerifier) {
        let ro_key = localStorage.getItem('ro_key')
        let ro_secret = localStorage.getItem('ro_secret')
        axios.post('/api/v1/social-login/twitter/token/verifier/' + oauthVerifier + '/key/' + ro_key + '/secret/' + ro_secret)
          .then(resp => {
            if (resp.status === 200) {
              this.$router.replace({query: null})
              if (localStorage.getItem('ro_key') !== null) {
                localStorage.removeItem('ro_key')
              }
              if (localStorage.getItem('ro_secret') !== null) {
                localStorage.removeItem('ro_secret')
              }
              this.modal.nome = resp.data.result.name
              this.modal.choose.show = false
              this.modal.price.show = true
            } else {
              swal('Attenzione', 'Attualmente la funziona di social login non è disponibile, ti invitiamo ad usare la form.', 'error')
            }
          })
      },
      saveDataToLS: function () {
        if (this.modal.saveData) {
          let dataToLS = JSON.parse(JSON.stringify(this.modal))

          delete dataToLS.checkMarketing
          delete dataToLS.price
          delete dataToLS.offer
          delete dataToLS.venditaCheck
          delete dataToLS.privacyCheck

          localStorage.setItem('user', JSON.stringify(dataToLS))
        } else {
          localStorage.removeItem('user')
        }
      },
      clickProcediAlPagamento: function () {
        if (this.isThereErrorsInCart) {
          swal('Attenzione', 'Attenzione! Uno o più file caricati presentano alcuni aspetti tecnici da approfondire. I tecnici di Elmec 3D effettueranno un\'analisi e la ricontatteranno a breve.', 'warning').then((result) => {
            if (result.value) {
              this.checkForceUserToChangePostProcess()
              // this.modal.offer.show = true
            }
          })
        } else {
          this.checkForceUserToChangePostProcess()
          // this.modal.offer.show = true
        }
      },
      checkForceUserToChangePostProcess: function () {
        // Used to force user to use AMT post_process
        // console.log('post_process', this.postProcesses)
        let postProcessToCheckInCartTitle = [this.postProcessToForce]

        // Check if one of postProcessToCheckInCartTitle is enabled in this.postProcesses
        if (!this.postProcesses.some(r => postProcessToCheckInCartTitle.indexOf(r.Title) >= 0)) {
          this.modal.offer.show = true
          return
        }

        // Get ID of post process to check
        let postProcessToCheckInCart = []
        postProcessToCheckInCartTitle.forEach(toCheck => {
          let found = this.postProcesses.find(p => p.Title === toCheck)
          if (found) postProcessToCheckInCart.push(parseInt(found.ID))
        })
        // console.log('postProcessToCheckInCart', postProcessToCheckInCart, postProcessToCheckInCartTitle)

        let userSelectedAtLeastOneNewPostProcess = false
        let id_cart = this.getIdCart()
        let cartItems = []

        if (id_cart && id_cart !== '') { // Get cart to check items
          axios.get('/api/v1/carts/' + id_cart)
            .then((response) => {
              if (response.status === 200) {
                let cartItemsResponse = response.data.result
                if (cartItemsResponse.rows && cartItemsResponse.rows.length >= 0) {
                  cartItems = cartItemsResponse.rows
                  // console.log('cartItems', cartItems)

                  // Check if one of all items has postProcess to check
                  cartItems.forEach(item => {
                    if (postProcessToCheckInCart.includes(item.post_process)) {
                      userSelectedAtLeastOneNewPostProcess = true
                    }
                  })
                  // console.log('userSelectedAtLeastOneNewPostProcess', userSelectedAtLeastOneNewPostProcess)

                  if (userSelectedAtLeastOneNewPostProcess) this.modal.offer.show = true
                  else this.modal.forcePostProcess.show = true // Let's be hated by the customer
                }
              }
            })
            .catch(() => {
              this.resetSiteDueInvalidCart()
            })
        }
      },
      modalForcePostProcessSayNo: function () {
        this.modal.forcePostProcess.show = false
        this.modal.offer.show = true
      },
      modalForcePostProcessSayYes: function () {
        let postProcessToForceID = this.postProcesses.find(p => p.Title === this.postProcessToForce).ID
        // console.log('postProcessToForceID', postProcessToForceID)
        this.buttonDisabled = true
        let id_cart = this.getIdCart()
        if (id_cart && id_cart !== '') { // Get cart to check items
          axios.patch('/api/v1/carts/' + id_cart + '/post-process/'+ postProcessToForceID + '/')
            .then((response) => {
              if (response.status === 201) {
                this.keyItemsNew++
                setTimeout(() => {
                  this.modal.forcePostProcess.show = false
                  this.buttonDisabled = false
                }, 1200)
              }
            })
            .catch(() => {
              this.buttonDisabled = false
              this.resetSiteDueInvalidCart()
            })
        }
      },
      // No more used
      makeid: function () {
        let text = ''
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

        for (let i = 0; i < 8; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length))
        }

        return text
      },
      startAuthorizationLinkedin: function () {
        this.$validator.validateAll('privacy').then(result => {
          if (result) {
            // Set the redirect URL. Adding the percent escape characthers is necessary.
            let redirectURL = window.location.href
            let clientID = '86wfa7x00gos0n'
            // Create a random string based on the time interval (it will be in the form linkedin12345679)
            let state = 'linkedin' + this.makeid()
            // Set preferred scope.
            let scope = encodeURI('r_emailaddress r_basicprofile')
            let urlAuthorization = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=' + clientID + '&redirect_uri=' + redirectURL + '&state=' + state + '&scope=' + scope
            window.location.href = urlAuthorization
          }
        })
      },
      getTokenAccessLinkedin: function (code, state) {
        this.$http.post('/ws-socialogin/socialoginLinkedin/getTokenAccess', {
          code: code,
          state: state
        }).then(response => {
          if (response.body.rc === 0) {
            this.$router.replace({path: '/', params: {}, query: {}})

            this.getInfoLinkedin(response.body.data)
          } else {
            swal('Attenzione', 'Attualmente la funziona di social login non è disponibile, ti invitiamo ad usare la form.', 'error')
          }
        }, response => {
          swal('Attenzione', 'Attualmente la funziona di social login non è disponibile, ti invitiamo ad usare la form.', 'error')
        })
      },
      getInfoLinkedin: function (tokensocial) {
        if (tokensocial !== null || tokensocial !== undefined || tokensocial !== '') {
          this.$http.get('/ws-socialogin/socialoginLinkedin/infoLinkedin?access_token=' + JSON.parse(tokensocial).access_token).then(response => {
            let dataResp = response.body

            if (dataResp.rc === 0) {
              this.showPriceBtn = false
              this.showPreventivoBtn = true

              let userdata = {
                name: dataResp.data.userData.firstName,
                surname: dataResp.data.userData.lastName,
                checkMarketing: this.modal.checkMarketing,
                socialogin: {
                  name: dataResp.data.userData.firstName,
                  surname: dataResp.data.userData.lastName,
                  mail: dataResp.data.userData.emailAddress
                }
              }

              this.modal.name = userdata.name
              this.modal.surname = userdata.surname

              localStorage.setItem('userdata', JSON.stringify(userdata))

              Bus.$emit('e3d_getPrices', userdata)
            } else {
              swal('Attenzione', 'Attualmente la funziona di social login non è disponibile, ti invitiamo ad usare la form.', 'error')
            }
          }, response => {
            swal('Attenzione', 'Attualmente la funziona di social login non è disponibile, ti invitiamo ad usare la form.', 'error')
          })
        }
      },
      isLogged: function () {
        let jsonObj = JSON.parse(localStorage.getItem('p3ditems'))

        if (jsonObj) {
          this.showPriceBtn = true
          this.showPreventivoBtn = false

          if (jsonObj.items) {
            if (jsonObj.items.length <= 0) {
              this.showPriceBtn = false
              this.showPreventivoBtn = false
            } else {
              if (jsonObj.userdata) {
                this.showPriceBtn = false
                this.showPreventivoBtn = true

                this.modal.name = jsonObj.userdata.name
                this.modal.surname = jsonObj.userdata.surname
                this.modal.mail = jsonObj.userdata.mail
              } else if (localStorage.getItem('userdata')) {
                let obj = JSON.parse(localStorage.getItem('userdata'))

                this.modal.name = obj.name
              }
            }
          }
        }
      },
      isMinPriceReached: function () {
        return !(parseFloat(this.totalPrice.minPrice) > 0 && parseFloat(this.totalPrice.tax) > parseFloat(this.totalPrice.minPrice))
      }
    }
  }
</script>

<style lang="less">

  #e3d-index {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;

    .loader-mask {
      opacity: 0.5;
    }

    .noPadding {
      padding: 0;
    }

    .viewer__iframe {
      height: 407px;
      border: 0;
    }

    .left {
      float: left;
    }

    .right {
      float: right;
    }

    .container-left {
      float: left;
      margin: 30px 0;

    }

    .btn-row {
      margin-top: 30px;
      margin-bottom: 30px;
    }

    #text-check-file {
      margin: 0 15px 0 0;
    }

    .visualizzazione-tot {
      margin-top: 30px;

      .items-tot-price {
        font-weight: bold;
        font-size: 24px;
        color: #626366;
        margin-top: 10px;

        .prices {
          text-align: right;
        }

        .min-prices-err {
          color: #fbbc05;
          font-size: 15px;
        }
      }
    }

    .button-blu-effect {
      height: 44px;
      background-color: #4285F4;
      border-radius: 15px;
      color: white;
      font-weight: bold;
      width: 200px;
      padding: 0;

      &:hover {
        background-color: #004B96;
        border: none;
      }
    }

    .container-preventivo {
      display: inline-block;

      .button-price-proceed {
        background-color: #4285F4;
        border-radius: 15px;
        color: white;
        font-weight: bold;
        width: 100%;

        &:hover {
          background-color: #004B96;
          border: none;
        }
      }
    }

    .custom-button-container {
      /*padding: 0 30px;*/

      .btn-custom {
        color: #4285f4;
        margin: 0 15px;
        height: 35px;

        &:hover {
          color: #fff;
        }
      }
    }

    .container-right {
      float: right;
      margin: 30px 0;
    }

    .error {
      color: red;
    }

    .modal-dialog {
      width: 630px;
    }

    .e3d-modal {
      overflow-y: scroll;

      .title-width-info {

        .dettaglio {
          height: 25px;
          float: right;
          width: auto;
          margin-top: 5px;
          color: #4285f4;
        }
      }

      .modal-content {
        margin-top: 50px;

        .modal-body {
          padding: 15px 25px;

          .form-group {
            width: 47%;

            &.full-width {
              width: 100%;
              padding: 0;
            }

            p {
              margin: 0;
              float: left;
            }

            input {
              margin-bottom: 15px;
              border-radius: 0;
              border-left: none;
              border-top: none;
              border-right: none;
              box-shadow: none;
            }

            .form-control {
              /*aggiungo sfondo e bordo*/
              background-color: #FFFFFF;
              border-bottom: 1px solid #fbbc05;
              transition: unset;

              &.form-control:focus {
                border: none;
                border-bottom: 1.5px solid #4285f4;
              }
            }

            .container-info-sdi {
              float: left;
              width: 20px;
              height: 20px;
              padding-top: 3px;
              margin-left: 10px;
              position: relative;

              .bordered-info {
                border: 1px solid black;
                height: 18px;
                width: 18px;
                border-radius: 10px;
                text-align: center;
                line-height: 16px;
                font-size: 14px;
                cursor: pointer;
              }

              svg {
                cursor: pointer;
              }

              .sdi-detail-open {
                position: absolute;
                padding: 5px;
                top: 25px;
                left: 0;
                width: 700px;
                height: 100px;
                z-index: 1000;
                background-color: white;
                border: 1px solid black;
              }
            }
          }

          .client-type {
            .floating-box {
              text-align: left;
              float: left;
              display: flex;
              display: -ms-flexbox;
              align-items: center;
              height: 60px;
              margin-bottom: 20px;

              &.icon {
                cursor: pointer;
                padding: 0 15px 10px 0;

                p {
                  width: 70%;
                  float: left;
                  margin: 0;
                  font-size: 14px;
                  text-transform: uppercase;
                }

                &.active {
                  color: #4285f4;

                  p {
                    color: #4285f4;
                    font-weight: bold;
                    font-size: 17px;
                    text-transform: uppercase;
                  }
                }

                &.user-icon {
                  svg {
                    /*height: 36px;*/
                    /*width: 34px;*/
                  }
                }
              }

              svg {
                float: left;
                margin-right: 20px;
              }
            }
          }

          .modal-buttons {
            margin-top: 15px;

            input {
              width: 40%;
            }

            .button-new-style {
              background-color: #4285F4;
              border-radius: 15px;
              color: white;
              font-weight: bold;
              width: 200px;
              padding: 0;

              &:hover {
                background-color: #004B96;
                border: none;
              }
            }

            .button-new-style-orange {
              background-color: #f7bc33;;
              border-radius: 15px;
              color: white;
              font-weight: bold;
              width: 200px;
              padding: 0;

              &:hover {
                background-color: #cd9401;;
                border: none;
              }
            }

            .button-new-style-transparent {
              border-radius: 15px;
              font-weight: bold;
              width: 200px;
              padding: 0;

              &:hover {
                background-color: #cccccc;;
                border: none;
              }
            }
          }

          .agreement {
            margin: 5px 0;
            padding: 5px 0;
            display: -webkit-inline-box;

            label::before {
              background-color: transparent;
            }

            .checkbox {
              display: none;
            }

            .checkbox-label {
              cursor: pointer;
              margin-right: 20px;
              margin-top: -10px;
            }

            .checkbox-label::before {
              -webkit-transition: all 0.3s ease-in-out;
              transition: all 0.3s ease-in-out;
              content: "";
              position: absolute;
              z-index: 1;
              width: 17px;
              height: 17px;
              border: 1px solid #C7C7C7;
              border-radius: 4px;
            }

            .checkbox:checked + label::before {
              -webkit-transform: rotate(-45deg) translate(0px, 0px);
              -ms-transform: rotate(-45deg) translate(0px, 0px);
              transform: rotate(-45deg) translate(0px, 0px);
              height: 10px;
              width: 18px;
              border: 2px solid #4285f4;
              border-radius: 0;
              border-top-style: none;
              border-right-style: none;

            }

            .checkbox + label::after {
              content: "";
              position: absolute;
              width: 17px;
              height: 17px;
              background: #FFFFFF;
              margin: 0px;
              border: 1px solid #FFFFFF;
              border-radius: 2px;
              color: #4285f4;
            }

            input[type=checkbox] + .lbl {
              z-index: 0;
            }

            span {
              color: #424242;

              &.error {
                color: red;

                .link-agreement {
                  color: red;
                }
              }

              .link-agreement {
                color: #424242;
                text-decoration: underline;
              }

              /*cursor: pointer;*/
            }
          }

        }

        .modal-footer {
          padding-top: 15px;
          padding-bottom: 10px;

          p {
            font-size: 11px;
          }
        }
      }
    }

    #chooseLogin {
      .modal-body {
        padding: 15px 20px;

        .text-click {
          cursor: pointer;
        }

        .content-left {
          float: left;
          text-align: center;
          border-right: 1px solid #c1c1c1;

          .choose-modal-icon {
            cursor: pointer;

            &:hover {
              color: #4285F4;
            }

            svg {
              width: 40px;
              height: 40px;
            }
          }

          .text-click {
            color: #4285F4;
            font-weight: bold;
            font-size: 17px;
            margin: 5px 0;
          }

          .social-login {

            .btn-twitter {
              float: right;
              color: #FFF;
              font-size: 14px;
              line-height: 22px;
              font-weight: normal;
              background-color: #55acee;
              text-transform: none;
              margin-bottom: 20px;

              &.temp {
                margin-top: 28px;
              }
            }

            .btn-social {
              position: relative;
              line-height: 29px;
              height: 32px;
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .img-social {
              float: right;

              &.img-linkedin {
                cursor: pointer;
                height: 32px;
              }
            }
          }
        }

        .content-right {
          float: right;
          text-align: center;

          .choose-modal-icon {
            cursor: pointer;
            color: #fbbc05;
          }

          p {
            color: #fbbc05;
            font-weight: bold;
            font-size: 17px;
            margin: 5px 0;
          }
        }

        .content-checkbox {
          float: left;
          margin-top: 25px;

          .dataEntry {
            margin: 5px 0;

            &.agreement {
              padding: 5px 0;
              /*display: -webkit-inline-box;*/
            }
          }
        }
      }

      .modal-footer {
        margin: 5px 20px;
        margin-top: 0;
        padding: 0;
        border-top: none;

        p {
          font-size: 11px;
        }
      }

    }

    #calcPrice {
      .modal-body {
        .dataEntry {
          &.agreement {
            float: left;
          }
        }
      }
    }

    #askOffer {
      .modal-body {
        .dataEntry {
          &.agreement {
            float: left;
          }
        }
      }
    }

    label::before {
      background-color: transparent;
    }

    .checkbox {
      display: none;
    }

    .checkbox-label {
      cursor: pointer;
      margin-right: 20px;
      margin-top: -10px;
    }

    .checkbox-label::before {
      -webkit-transition: all 0.3s ease-in-out;
      transition: all 0.3s ease-in-out;
      content: "";
      position: absolute;
      z-index: 1;
      width: 17px;
      height: 17px;
      border: 1px solid #C7C7C7;
      border-radius: 4px;
    }

    .checkbox:checked + label::before {
      -webkit-transform: rotate(-45deg) translate(0px, 0px);
      -ms-transform: rotate(-45deg) translate(0px, 0px);
      transform: rotate(-45deg) translate(0px, 0px);
      height: 10px;
      width: 18px;
      border: 2px solid #4285f4;
      border-radius: 0;
      border-top-style: none;
      border-right-style: none;

    }

    .checkbox + label::after {
      content: "";
      position: absolute;
      width: 17px;
      height: 17px;
      background: #FFFFFF;
      margin: 0px;
      border: 1px solid #FFFFFF;
      border-radius: 2px;
      color: #4285f4;
    }

    input[type=checkbox] + .lbl {
      z-index: 0;
    }

    span {
      color: #424242;

      &.error {
        color: red;

        .link-agreement {
          color: red;
        }
      }

      .link-agreement {
        color: #424242;
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexNew.vue